// this contains named variables for the base tints and hues used in the other colour files.
// NOTE: These colours should never be used outside of fe-brary.
// Use colours from colour-scheme or color-atom-palette instead

export default (() => ({
  colour: {
    domainNavy400: '#22365a',
    domainNavy500: '#0b2047',
    domainNavy600: '#071939',
    domainGreen25: '#f3faf2',
    domainGreen50: '#e6f6e5',
    domainGreen100: '#b6e4b2',
    domainGreen200: '#86d37f',
    domainGreen300: '#56c24c',
    domainGreen400: '#26b019',
    domainGreen500: '#0ea800',
    domainGreen600: '#0c9700',
    domainGreen700: '#0b8600',
    domainGreen800: '#086400',
    domainLobster100: '#ffcec3',
    domainLobster500: '#ff613d',
    domainLobster600: '#f74a23',
    domainCanary500: '#fc0',
    domainCanary100: '#ffefaf',
    domainTurquoise500: '#05bbb6',
    domainTurquoise100: '#ccf1f0',
    domainGrimace500: '#612b87',
    domainBlurple500: '#514aea'
  }
}));